import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { buildImageHtml } from '../../utils/richEmailEditorUtils';

const ImageInsertPopover = ({ isOpen, onClose, onInsert }) => {
  const [url, setUrl] = useState('');
  const [alt, setAlt] = useState('');
  const [width, setWidth] = useState('');

  useEffect(() => {
    if (isOpen) {
      setUrl('');
      setAlt('');
      setWidth('');
    }
  }, [isOpen]);

  const handleApply = () => {
    if (!url.trim()) return;
    onInsert?.(buildImageHtml({ url: url.trim(), alt: alt.trim(), width: width.trim() || undefined }));
    onClose?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent className="max-w-md" data-testid="image-insert-modal">
        <DialogHeader>
          <DialogTitle>Add Image</DialogTitle>
          <DialogDescription className="sr-only">
            Insert an image into the email body.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label htmlFor="image-url">Image URL</Label>
            <Input
              id="image-url"
              data-testid="image-url-input"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com/image.png"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="image-alt">Alt text</Label>
            <Input
              id="image-alt"
              value={alt}
              onChange={(e) => setAlt(e.target.value)}
              placeholder="Description"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="image-width">Width (optional)</Label>
            <Input
              id="image-width"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              placeholder="e.g. 320"
            />
          </div>
          <p className="text-xs text-slate-500">
            Image upload integration coming soon. Use a hosted image URL for now.
          </p>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose}>Cancel</Button>
            <Button
              onClick={handleApply}
              disabled={!url.trim()}
              className="bg-blue-600 hover:bg-blue-700 text-white"
              data-testid="image-insert-apply"
            >
              Insert image
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageInsertPopover;
